import React, { FC, Suspense }                     from 'react';
import { LoadingIndicator, LoadingIndicatorProps } from '../views/components/util/loading/LoadingIndicator';

const withSuspense = ( Component: FC<any>, loadingIndicatorProps?: LoadingIndicatorProps ) => ( props: any = {} ) => (
	
	<Suspense fallback={ <LoadingIndicator isActive={ true } dimmer={ false } { ...loadingIndicatorProps } /> }>{ <Component { ...props }/> }</Suspense>

);

const useSuspense = () => {
	
	return { withSuspense }
}

export { useSuspense }
